import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavDropdown.css';

const NavDropdown = ({ elements, hrefCategory, title, items = [], bannerImage, mostImportantCount = 2, moreCategoriesCount = items.length - 2, isOpen, onToggle }) => {
  const [isHoverOpen, setIsHoverOpen] = useState(false);

  // Determine if dropdown is open based on hover or controlled state
  const open = isOpen !== undefined ? isOpen : isHoverOpen;

  // Ensure counts are valid and don't exceed items length
  const safeMostImportantCount = Math.min(mostImportantCount, items.length);
  const safeMoreCategoriesCount = Math.min(moreCategoriesCount, items.length - safeMostImportantCount);

  return (
    <div className="nav-dropdown"
      onMouseEnter={() => {
        if (window.matchMedia('(max-width: 900px)').matches) return;
        setIsHoverOpen(true);
        if (onToggle) onToggle();
      }}
      onMouseLeave={() => {
        if (window.matchMedia('(max-width: 900px)').matches) return;
        setIsHoverOpen(false);
        if (onToggle) onToggle();
      }}
    >
      <Link to={hrefCategory || '/search'} className="nav-dropdown-link">{title}</Link>
      {open && (
        <div className="nav-dropdown-menu">
          <div className="nav-dropdown-column">
            <div className="nav-dropdown-header">Most Important</div>
            {safeMostImportantCount > 0 ? (
              items.slice(0, safeMostImportantCount).map((item, index) => (
                <Link key={index} to={item.link} className="nav-dropdown-item">{item.label}</Link>
              ))
            ) : (
              <div className="nav-dropdown-item">No items available</div>
            )}
          </div>
          <div className="nav-dropdown-column">
            <div className="nav-dropdown-header">More Categories</div>
            {safeMoreCategoriesCount > 0 ? (
              items.slice(safeMostImportantCount, safeMostImportantCount + safeMoreCategoriesCount).map((item, index) => (
                <Link key={index + safeMostImportantCount} to={item.link} className="nav-dropdown-item">{item.label}</Link>
              ))
            ) : (
              <div className="nav-dropdown-item">No items available</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavDropdown;
